import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
  faLocationDot,
  faBuilding,
  faShieldHalved,
  faHardHat,
  faCalendarDays,
  faSliders
} from "@fortawesome/free-solid-svg-icons";

const PROPERTY_TYPE_OPTIONS = [
  "All Types",
  "Plotted Development",
  "Commercial",
  "Mixed Development",
  "Residential"
];

const FILTERS = [
  {
    key: "location",
    icon: faLocationDot,
    label: "Location",
    value: "All Locations",
    options: [
      "All Locations",
      "Hyderabad",
      "Ranga Reddy",
      "Nizamabad",
      "Medchal",
      "Sangareddy",
      "Warangal"
    ]
  },
  {
    key: "propertyType",
    icon: faBuilding,
    label: "Project Type",
    value: "All Types",
    options: PROPERTY_TYPE_OPTIONS
  },
  {
    key: "approval",
    icon: faShieldHalved,
    label: "Approval",
    value: "Any Approval",
    options: ["Any Approval", "HMDA", "DTCP", "GHMC", "RERA"]
  },
  {
    key: "builderName",
    icon: faHardHat,
    label: "Builder",
    value: "All Builders",
    options: ["All Builders", "Aparna", "My Home", "Prestige", "Brigade"]
  },
  {
    key: "possession",
    icon: faCalendarDays,
    label: "Possession",
    value: "Any Time",
    options: ["Any Time", "On-Going Project", "New Project"]
  }
];

const DEFAULT_FILTER_VALUES = Object.fromEntries(FILTERS.map((filter) => [filter.key, filter.value]));

const isDefaultFilterValue = (key, value) => value == null || value === "" || value === DEFAULT_FILTER_VALUES[key];

/** Strip unset / default UI values before search. */
export const toAppliedFilters = (values = {}) => Object.fromEntries(
  Object.entries(values).filter(([key, value]) => !isDefaultFilterValue(key, value))
);

function FilterBar({ values = DEFAULT_FILTER_VALUES, onChange, onApply }) {
  const [isApplying, setIsApplying] = useState(false);

  const handleApply = async () => {
    setIsApplying(true);
    try {
      await onApply?.(toAppliedFilters(values));
    } finally {
      setIsApplying(false);
    }
  };

  return <form className="vd-filter-wrap" onSubmit={(event) => {
    event.preventDefault();
    handleApply();
  }}>
      {FILTERS.map((f) => <div key={f.key} className="vd-filter-item">
          <div className="vd-fl-label">
            <FontAwesomeIcon icon={f.icon} className="fa-icon" />
            {f.label}
          </div>
          <div className="vd-fl-val">
            <select
              className="vd-fl-select"
              value={values[f.key] ?? f.value}
              onChange={(event) => onChange?.({ ...values, [f.key]: event.target.value })}
              aria-label={f.label}
            >
              {f.options.map((option, index) => {
                if (typeof option === "string") {
                  return <option key={option} value={option}>
                      {option}
                    </option>;
                }

                return <optgroup key={`${option.group}-${index}`} label={option.group}>
                    {option.options.map((groupOption) => <option key={`${option.group}-${groupOption}`} value={groupOption}>
                        {groupOption}
                      </option>)}
                  </optgroup>;
              })}
            </select>
          </div>
        </div>)}
      <button className="vd-filter-more-btn" type="submit" disabled={isApplying}>
        <FontAwesomeIcon icon={faSliders} />
        {isApplying ? "Applying..." : "Apply Filters"}
      </button>
    </form>;
}

export {
  FilterBar as default,
  DEFAULT_FILTER_VALUES
};
